import './menu.css';

import CtaBtn from '../btn/CtaBtn';

const Menu = ({ modalRef, handleModal }) => {
  const SmoothScroll = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute('href');
    const element = document.querySelector(target);
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  //
  return (
    <div className="Navbars">
      <ul className="NavbarWrappers">
        {/* <li className="NavbarElement ">
          <a className="link" href="#about" onClick={SmoothScroll}>
            About
          </a>
        </li> */}
            <li className="NavbarElement">
          <a className="link" href="#our-story" onClick={SmoothScroll}>
            Our Story
          </a>
        </li>
        <li className="NavbarElement">
          <a className="link" href="#why-us" onClick={SmoothScroll}>
            Why Us
          </a>
        </li>
    
        <li className="NavbarElement">
          <a className="link" href="#get-onboard" onClick={SmoothScroll}>
            Get Onboard
          </a>
        </li>
        <li className="NavbarElement">
          <CtaBtn
            name="Book Appointment"
            handleModal={handleModal}
            modalRef={modalRef}
          />
        </li>
      </ul>
    </div>
  );
};

export default Menu;
